export const uploadConstants = {
    acceptImage: '.png,.jpg,',
    acceptVideo: '.mp4',
    acceptImageAndVideo: '.png,.jpg,.mp4',
    maxSize: "102400"
}